import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

import { TsButtonModule, TSIconModule } from 'tsui';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { FormFieldsModule } from 'app/shared/components/form-fields/form-fields.module';
import { SimilarItemsListComponent } from './@shared/similar-items-list/similar-items-list.component';
import { CustomFormComponent } from './custom-form/custom-form.component';
import { CustomItemsNameComponent } from './custom-fields/custom-items-name/custom-items-name.component';
import { CustomAddressComponent } from './custom-fields/custom-address/custom-address.component';
import { CustomDealLayoutComponent } from './custom-fields/custom-deal-layout/custom-deal-layout.component';
import { CustomFileUploadComponent } from './custom-fields/custom-file-upload/custom-file-upload.component';
import { CustomAddPropertiesComponent } from './custom-fields/custom-add-properties/custom-add-properties.component';
import { CustomTagListComponent } from './custom-fields/custom-tag-list/custom-tag-list.component';
import { CustomContactCategoryComponent } from './custom-fields/custom-contact-category/custom-contact-category.component';
import { CustomAddressStringComponent } from './custom-fields/custom-address-string/custom-address-string.component';
import { CustomAssociateCompanyComponent } from './custom-fields/custom-associate-company/custom-associate-company.component';

const MATERIAL_IMPORTS = [
  MatSelectModule,
  MatProgressBarModule,
  MatFormFieldModule,
  MatInputModule,
  MatTooltipModule,
  MatProgressSpinnerModule,
  MatAutocompleteModule,
  MatChipsModule,
  MatMenuModule,
];

const CUSTOM_FORM_COMPONENTS = [
  SimilarItemsListComponent,
  CustomFormComponent,
  CustomItemsNameComponent,
  CustomAddressComponent,
  CustomDealLayoutComponent,
  CustomFileUploadComponent,
  CustomAddPropertiesComponent,
  CustomTagListComponent,
  CustomContactCategoryComponent,
  CustomAddressStringComponent,
  CustomAssociateCompanyComponent,
];

const TSUI_MODULES = [TsButtonModule, TSIconModule];

@NgModule({
  declarations: [...CUSTOM_FORM_COMPONENTS],
  imports: [
    CommonModule,
    FormFieldsModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    ...MATERIAL_IMPORTS,
    ...TSUI_MODULES,
  ],
  exports: [...CUSTOM_FORM_COMPONENTS],
})
export class CustomFormModule {}
